<div class="w-full" *ngIf="investors > 4 || yourInvest > 0">
  <div [class]="'flex ' + wrapClass + ' pl-6 gap-x-24'">
    <div *ngIf="investors > 4">
      <div class="flex">
        <div *ngFor="let avatar of initials" [class]="'rounded-full outline outline-1 outline-white -mx-8 ' + avtClass + ' ' + avatar.background">
          <p [class]="'text-center font-sans text-white ' + capClass">{{ avatar.letter }}</p>
        </div>
      </div>
    </div>
    <div class="flex flex-col">
      <p class="font-sansMedium text-m leading-[18.2px]" [ngClass]="{'text-[#0f5e42]' : isFlexibleCompensation, 'bg-gradient-2-text linear-gradient-2' : !isFlexibleCompensation}" *ngIf="yourInvest > 0 || yourPendingInvest > 0">
        <span *ngIf="status !== 15 && yourInvest > 0 && yourPendingInvest === 0">{{ 'OVERVIEW_PROJECT.YOU_INVEST' | translate }} {{ yourInvest | number:'1.0-2':'es' }} €</span>
        <span *ngIf="status !== 15 && yourPendingInvest > 0">Tienes {{ yourPendingInvest }} € pendientes de formalizar</span>
        <span *ngIf="status === 15">{{ 'OVERVIEW_PROJECT.YOU_RESERVE' | translate }} {{ yourInvest | number:'1.0-2':'es' }} €</span>
      </p>
      <p *ngIf="investors > 4 && specificText === null" [class]="'font-sans ' + txtClass">
        <span class="font-sansMedium">{{ investors }} personas</span>
        <span *ngIf="status !== 15"> {{ 'INVEST.ALREADY_INVESTED' | translate }}</span>
        <span *ngIf="status === 15"> {{ 'INVEST.ALREADY_RESERVED' | translate }}</span>
      </p>
      <p *ngIf="specificText !== null" [class]="'font-sans [&>span]:text-orange-100 [&>span]:underline [&>span]:underline-offset-6' + txtClass" [innerHTML]="specificText">{{ specificText }}</p>
    </div>
  </div>
</div>